<template>
  <v-dialog v-model="dialog" :width="width">
    <v-card>
      <v-card-title :class="dialogHeaderClasses" :style="dialogHeaderStyles">
        <slot name="header">
          <div v-if="title">
            {{ title }}
          </div>
        </slot>
      </v-card-title>

      <v-card-text :class="dialogBodyClasses" :style="dialogBodyStyles">
        <slot></slot>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions :class="dialogFooterClasses" :style="dialogFooterStyles">
        <v-spacer></v-spacer>
        <slot name="footer">
          <v-btn color="primary" text @click="$emit('input', false)">
            بستن
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    value: {
      type: [Boolean, String],
      default: false,
    },
    width: {
      default: '500',
    },
    dialogHeaderClasses: {
      type: String,
      default: 'text-h5 grey lighten-2',
    },
    dialogHeaderStyles: {
      type: String,
    },
    dialogBodyClasses: {
      type: String,
    },
    dialogBodyStyles: {
      type: String,
    },
    dialogFooterClasses: {
      type: String,
    },
    dialogFooterStyles: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {},
};
</script>
<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #4aae9b;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  flex-direction: column;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
